import { useState } from 'react'
import { TEMPLATE_MODULES } from '../../../../helpers/liveReportHelpers/isTemplateAvailable'

/**
 * 'Zichtbaar voor' in de kop van een template in de bouwer (alleen Deccos):
 * per module een vinkje. Een organisatie ziet de template alleen als ze álle
 * aangevinkte modules aan heeft (isTemplateAvailable, en voor Decca
 * templateAvailableForTenant). Geen vinkje = iedereen.
 * Gestuurd door het document: na opslaan komt de nieuwe stand via de snapshot.
 * AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (zichtbaarheid templates)
 *
 * @param {object} props
 * @param {Array<string>} props.modules - `RequiredModules` van de template
 * @param {(modules: Array<string>) => Promise<void>} props.onChange - Schrijft de nieuwe lijst weg
 * @returns {JSX.Element}
 */
const TemplateModulesMetaItem = ({ modules, onChange }) => {
    const [error, setError] = useState('')
    const current = Array.isArray(modules) ? modules : []

    /** @param {string} key @param {boolean} checked */
    const toggleHandler = (key, checked) => {
        // Vaste volgorde (die van TEMPLATE_MODULES), zodat dezelfde keuze altijd
        // dezelfde lijst geeft.
        const next = TEMPLATE_MODULES
            .map((m) => m.key)
            .filter((k) => (k === key ? checked : current.includes(k)))
        setError('')
        onChange(next).catch(() => setError('Opslaan is niet gelukt. Probeer het opnieuw.'))
    }

    return (
        <div className="template-viewer-meta-item template-modules">
            <span className="meta-label">Zichtbaar voor:</span>
            {TEMPLATE_MODULES.map((m) => (
                <label key={m.key} className="template-modules__option">
                    <input
                        type="checkbox"
                        checked={current.includes(m.key)}
                        onChange={(e) => toggleHandler(m.key, e.target.checked)}
                    />
                    {m.label}
                </label>
            ))}
            {current.length === 0 && <span className="template-modules__hint">Geen vinkje: zichtbaar voor iedereen</span>}
            {error && <span className="template-modules__error" role="alert">{error}</span>}
        </div>
    )
}

export default TemplateModulesMetaItem
